export default __webpack_public_path__ + "static/media/kansas.886458be.png";